import request from '../request';

export default {
  // 评论-新增
  create(data) {
    return request.post('/comment/create', data);
  },

  // 评论-更新
  edit(data) {
    return request.post('/comment/edit', data);
  },

  // 评论-我的
  myComment(data) {
    return request.get('/comment/myComment', data);
  },

  // 评论-列表
  list(data) {
    return request.get('/comment/list', data);
  },

  // 评论-删除
  delete(data) {
    return request.post('/comment/delete', data);
  },

  // 评论-回复列表
  getReply(data) {
    return request.get('/comment/getReply', data);
  },

  // 评论-根据id获取
  getReplyRow(data) {
    return request.get('/comment/getReplyRow', data);
  },
};
